<template>

  <page-section
      title="Правила партнерської програми з ТОВ «ВІСТАДІ», код ЄДРПОУ 44338526"
      class="py-16 px-4"
  >

    <div style="max-width: 800px" class="mx-auto py-16">
      <h4 class="wsDARKER font-weight-regular">
        Дані правила є частиною публічної оферти і підписаних в письмовому вигляді договорів з ТОВ «ВІСТАДІ» (код ЄДРПОУ 44338526)  (далі — Виконавець).
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        Дані правила приймаються усіма клієнтами Виконавця в момент реєстрації на сайті Виконавця та акцепту публічної оферти Виконавця.
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        Одночасно з цим клієнту Виконавця також присвоюється статус Партнера і персональний ідентифікаційний номер Партнера (Партнерський код).
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        Партнерський код — є промокод для підключення нових клієнтів до сервісів ТОВ «ВІСТАДІ» (https://westudy.ua/?pref=*реферальнийкод*)
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        Участь в партнерській програмі є добровільною і дозволяє в разі рекомендації Партнером послуг Виконавця третім особам отримувати Партнеру бонусні кошти, які він може використовувати в якості знижки на послуги Виконавця або за запитом перерахувати на банківський рахунок.
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        Облік нових клієнтів  Партнера ведеться Виконавцем в Особистому кабінеті клієнта за посиланням - (https://westudy.ua/dashboard/westudy_partner)
      </h4>


      <h4 class="wsDARKER font-weight-regular mt-5">
        Партнер повністю визнає дані з обліку залучених Клієнтів і нарахувань бонусних коштів в Особистому кабінеті Виконавця. Партнер повністю визнає дані з обліку залучених Клієнтів. За фактом порушень цих Правил, Виконавець залишає за собою право анулювати ті чи інші нарахування, видалити Клієнта зі списку залучених Партнером клієнтів або ж повністю відмовити Партнеру в участі в партнерській програмі.
      </h4>


      <h3 class="wsDARKER  mt-5">
        Терміни, які використовуються в цих правилах:
      </h3>


      <h4 class="wsDARKER font-weight-regular mt-5">
        <b>Партнерський код (промокод)</b>— Персональний Ідентифікаційний Номер Партнера, який присвоюється Партнеру в момент реєстрації на сайті Виконавця за адресою - (https://westudy.ua/)
      </h4>


      <h4 class="wsDARKER font-weight-regular mt-5">
        <b>Партнер</b>— юридична або фізична особа, яка зареєструвалася на сайті Виконавця за адресою - (https://westudy.ua), якому Виконавцем присвоєно Партнерський код (промокод), для ідентифікації нових клієнтів Виконавця, які прийшли за рекомендацією Партнера.
      </h4>



      <h4 class="wsDARKER font-weight-regular mt-5">
        <b>Клієнт</b>— юридична або фізична особа уклала, на підставі інформації отриманої від Партнера, договір з Виконавцем і який отримав одну або кілька послуг, що надаються Виконавцем.
      </h4>


      <h4 class="wsDARKER font-weight-regular mt-5">
        <b>Кукі (cookie)</b>— інформація, що залишається веб-сервером в браузері Клієнта з метою збереження даних, специфічних для даного Клієнта, в момент відвідування Клієнтів сайту Виконавця - (https://westudy.ua/)
      </h4>


      <h4 class="wsDARKER font-weight-regular mt-5">
        Зокрема, з метою ідентифікації Партнера, від якого Клієнт отримав інформацію про послуги Виконавця, в cookie зберігається інформація про партнерський код (промокод) Партнера.
      </h4>


      <h4 class="wsDARKER font-weight-regular mt-5">
        <b>Реферальний сайт</b>— сайт, управління яким підтверджено Партнером і який доданий в Особистому кабінеті Виконавця як реферальний.
      </h4>


      <h4 class="wsDARKER font-weight-regular mt-5">
        При переході Клієнтів з реферального сайту на сайт Виконавця Партнерський код Партнера на сторінці реєстрації на сайті Виконавця проставляється автоматично.
      </h4>

      <h3 class="wsDARKER  mt-5">
        1. Порядок обліку клієнтів і розрахунків
      </h3>

      <h4 class="wsDARKER font-weight-regular mt-5">
        1.1. Партнерська програма доступна для Партнерів, що використовують тарифні плани зазначені на сайті Виконавця за адресою (https://westudy.ua/pricing)
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        1.2. Облік залучених Партнером Клієнтів проводиться тільки в тому випадку, якщо в момент реєстрації Клієнта на сайті Виконавця зазначений Партнерський код (промокод) у відповідному полі.
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        Партнерський код проставляється автоматично:
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        В разі якщо Клієнт перейшов на сайт Виконавця за гіперпосиланням, яке містило Партнерський код. При цьому враховується тільки перший перехід за гіперпосиланням з Партнерським кодом, інші переходи з Партнерським кодом ігноруються. Для обліку Клієнта приймаються cookie, термін дії яких не перевищує 3 (трьох) місяців в разі якщо Клієнт перейшов на сайт Виконавця з реферального сайту.
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        1.3. За надання залучення Клієнтів по Програмі партнерства, Партнеру, на акаунт нараховуються бонусні кошти, які Партнер може використовувати в якості знижки на послуги Виконавця або за запитом перерахувати на банківський рахунок.
      </h4>


      <h4 class="wsDARKER font-weight-regular mt-5">
        1.4. Нарахування бонусних коштів здійснюються автоматично після оплати послуг Виконавця залученими Клієнтом. Нарахування бонусних коштів проводяться з урахуванням обмежень, встановлених цими Правилами.
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        1.5. Нарахування бонусних коштів відбуваються тільки на активному (не заблокованому) акаунті Партнера, тобто тільки в тому випадку, якщо Партнер користується в момент нарахувань послугами Виконавця. При видаленні облікового запису Партнера, бонусні кошти і залучені Клієнти — анулюються і відновленню не підлягають.
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        1.6. На розсуд Виконавця, нарахування бонусних коштів може проходити ручну перевірку. Термін перевірки — до 2 місяців.
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        1.7. Розмір нарахованих бонусних коштів визначається шляхом додавання нарахувань з кожної оплати зробленої Клієнтом, відповідно до п. 2 цих Правил.
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        1.8. Всі випадки порушення даних правил ретельно аналізуються і якщо порушення підтверджується, то Партнеру виноситься попередження, а нарахування та залучені Партнером Клієнти з порушеннями Правил анулюються. Якщо випадок порушення правил повторюється Виконавець забороняє Партнеру брати участь в Програмі партнерства — всі бонусні кошти і залучені Партнером Клієнти анулюються.
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        1.9. Партнерам забороняється: Виробляти примусову переадресацію користувачів на сайт (-и) Виконавця через рекламне посилання або банер; Виробляти рекламну розсилку (спам) із зазначенням рекламної інформації Виконавця або сайту Виконавця; Використання і поширення інформації про Виконавця на веб-ресурсах, які порушують чинне законодавство України; Розміщувати рекламні матеріали на ресурсах, де вже присутній хоча б одне гіперпосилання на сайт Виконавця без вмісту будь-якого Партнерського коду, без попереднього узгодження з Виконавцем. В тому числі, забороняється залучення клієнтів з використанням контекстної реклами в пошукових системах (Yandex.ru, Mail.ru та ін.) По будь-яким пошуковим запитам. Клієнти, що переходять з пошукових систем, в партнерській програмі, враховуватися не будуть; Надавати потенційним Клієнтам інформацію про вартість послуг, яка відрізняється від зазначеної на сайті Виконавця (https://westudy.ua/pricing) чи іншу інформацію про Виконавця та його послугах, яка не відповідає дійсності. Реєструвати акаунти для особистого використання через свою партнерську програму, зокрема акаунт Партнера і Клієнта не можуть бути зареєстровані на одну і ту ж особу;
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        1.10. Виконавець, в будь-який момент, в односторонньому порядку, має право змінювати умови партнерської програми і справжні Правила, а також призупинити або повністю скасувати партнерську програму і анулювати нараховані бонусні кошти.
      </h4>

      <h3 class="wsDARKER  mt-5">
        2. Розмір нарахувань
      </h3>

      <h4 class="wsDARKER font-weight-regular mt-5">
        2.1. Загальний обсяг нарахування коштів складає - 200 % від обраного та сплаченого місячного тарифу Клієнта протягом 4 місяців.
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        2.2. Загальний обсяг виплат Партнеру розподіляється на 4 місяці:
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        Виплата № 1. Складає 50% від місячного тарифу Клієнта, яка нараховується  на  бонусний рахунок Партнеру після завершення оплати клієнтом місячного тарифу на рахунок ТОВ «ВІСТАДІ» (код ЄДРПОУ 44338526) за 1й місяць платного користування платформою - (https://westudy.ua/).
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        Виплата № 2. Складає 50% від місячного тарифу Клієнта, яка нараховується  на  бонусний рахунок Партнеру після завершення оплати клієнтом місячного тарифу на рахунок ТОВ «ВІСТАДІ» (код ЄДРПОУ 44338526) за 2й місяць платного користування платформою - (https://westudy.ua/).
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        Виплата № 3. Складає 50% від місячного тарифу Клієнта, яка нараховується  на  бонусний рахунок Партнеру після завершення оплати клієнтом місячного тарифу на рахунок ТОВ «ВІСТАДІ» (код ЄДРПОУ 44338526) за 3й місяць платного користування платформою - (https://westudy.ua/).
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        Виплата № 4. Складає 50% від місячного тарифу Клієнта, яка нараховується  на  бонусний рахунок Партнеру після завершення оплати клієнтом місячного тарифу на рахунок ТОВ «ВІСТАДІ» (код ЄДРПОУ 44338526) за 4й місяць платного користування платформою - (https://westudy.ua/).
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        2.3. Виконавець має право змінити розмір і порядок нарахування бонусних коштів в період проведення промоакцій, або ж повністю скасувати нарахування таких бонусних коштів.
      </h4>

      <h4 class="wsDARKER font-weight-regular mt-5">
        2.4. У разі повернення оплати Клієнтом сума нарахованих Партнеру бонусних коштів підлягає перерахунку або утриманню відповідної суми при наступному партнерському нарахуванні.
      </h4>

    </div>









  </page-section>


</template>
<script>
export default {
  name: "HomeMainPartnerProgram"
}
</script>

<style scoped>

</style>